import React, { useEffect, useState } from 'react';
import { DrawLotsApi } from '../../Utils/Api/DrawLotsApi';
import { useAlert } from 'react-alert';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { splitQuery } from '../../Shares/CommonUtil';
import { cdnUrlConfig } from '../../Utils/atoms';
import PrizePopUp from './PopUp/PrizePopUp';
import { initUnity, setUnityMember } from '../../Utils/unityUtil';
import { EventApi } from '../../Utils/Api/EventApi';

const DrawLotsMain = () => {
	const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;
	const alert = useAlert();
	const [_rewardResult, setRewardResult] = useState({}); //룰렛결과 오브젝트
	const [_rewardLog, setRewardLog] = useState({}); //룰렛결과 로그
	const [lever, setLever] = useState('');
	const [moveBalls, setMoveBalls] = useState('');
	const [moveBalls2, setMoveBalls2] = useState('');
	const [exitBall, setExitBall] = useState('');
	const [turnBall, setTurnBall] = useState('');
	const [randomColorBall, setRandomColorBall] = useState('');
	const [prizePopup, setPrizePopup] = useState(0);
	const [attendance, setAttendance] = useState(false);
	const [interiorTicket, setInteriorTicket] = useState(false);
	const [coinCount, setCoinCount] = useState(0);
	const [member_se, setMemberSe] = useState(0);
	const [isLoading, setisLoading] = useState(false);

	// 주소에서 event_se 가져오기
	const { search } = useLocation();
	const querys = splitQuery(search);
	const event_se = querys['event_se'] ? querys['event_se'] : 0;

	// 믹스패널용 이벤트 정보
	const [eventName, setEventName] = useState('');
	const [eventCategoryType, setEventCategoryType] = useState('');

	// member_se 호출에 실패했을 경우의 안내 팝업
	const showErrorAlert = (message) => {
		alert.error(message, {
			timeout: 5000, // 5 seconds
		});
	};

	// 카테고리 코드에 따른 카테고리 명을 반환한다
	const getEventCategoryName = (category_cd) => {
		let result = '';
		if (category_cd === 0) {
			result = '기본';
		} else if (category_cd === 1) {
			result = '룰렛';
		} else if (category_cd === 2) {
			result = '캡슐';
		}

		return result;
	};

	// Unity 함수 호출
	useEffect(() => {
		if (event_se > 0) {
			initUnity();
			setUnityMember(
				(member_se) => setMemberSe(member_se),
				(msg) => showErrorAlert(msg)
			);
		}
	}, []);

	// GET 이벤트 상세 정보 API
	useEffect(() => {
		EventApi.GetEventStatus(event_se)
			.then((response) => {
				const { status, data } = response;
				if (status === 200) {
					setEventName(data.data.event_nm);
					setEventCategoryType(
						getEventCategoryName(data.data.event_category_cd)
					);
				}
			})
			.catch((error) => {
				const { status, data } = error.response;
				if (status === 404) {
					alert.error(data.msg, {
						timeout: 10000, // 10 seconds
					});
				}
			});
	}, [event_se]);

	// start 버튼 클릭
	const handleStartClick = () => {
		if (isLoading) {
			return;
		}
		if (member_se > -1 && coinCount > 0) {
			setisLoading(true);
			const data = { event_se: event_se, member_se: member_se };
			DrawLotsApi.PostDrawLots(data).then((response) => {
				const {
					status,
					data: { rewardResult, rewardLog },
				} = response;
				if (status === 200) {
					setRewardResult(rewardResult);
					setRewardLog(rewardLog);
					setCoinCount((prev) => prev - 1);
					colorBall(rewardResult.rank_no);
				}
			});
			fallBallMove();
		}
	};

	// start 버튼 클릭 시 애니메이션 동작 순서
	const fallBallMove = () => {
		leverRotate(); // 레버 회전
		ballMove(); // 캡슐 안 볼 애니메이션
		ballMove2(); // 캡슐 안 볼 애니메이션2
		ballFall(); // 뽑은 캡슐 out
		ballTurn(); // 캡슐 낙하 후 이동 및 회전
		showPopup(); // 팝업 on, 애니메이션 초기화
	};

	const leverRotate = () =>
		setTimeout(() => {
			setLever('rotation');
		}, 300);
	const ballMove = () =>
		setTimeout(() => {
			setMoveBalls('on');
		}, 800);
	const ballMove2 = () =>
		setTimeout(() => {
			setMoveBalls2('last-turn');
		}, 1700);
	const ballFall = () =>
		setTimeout(() => {
			setExitBall('down');
		}, 2200);
	const ballTurn = () =>
		setTimeout(() => {
			setTurnBall('turn');
		}, 3300);
	const showPopup = () =>
		setTimeout(() => {
			setPrizePopup(1);
			setLever('');
			setMoveBalls('');
			setMoveBalls2('');
			setExitBall('');
			setTurnBall('');
			setRandomColorBall('');
			setisLoading(false);
		}, 4500);

	// 보상에 따른 뽑기 캡슐 색상 지정
	const colorBall = (no) => {
		switch (no) {
			case 1:
			case 2:
				setRandomColorBall('blue');
				break;
			case 3:
				setRandomColorBall('green');
				break;
			case 4:
				setRandomColorBall('purple');
				break;
			case 5:
			case 7:
				setRandomColorBall('yellow');
				break;
			case 6:
			case 8:
				setRandomColorBall('red');
				break;
		}
	};

	useEffect(() => {
		// 팝업 표출 시 레버 초기화
		if (prizePopup === 1) setLever('');
	}, [prizePopup]);

	// GET 코인
	useEffect(() => {
		if (member_se > 0) {
			DrawLotsApi.GetDrawLotsCount(member_se, event_se).then((response) => {
				const {
					status,
					data: { attendance, miniGame, interiorTicket, coinCount },
				} = response;
				if (status === 200) {
					setAttendance(attendance);
					setInteriorTicket(interiorTicket);
					setCoinCount(coinCount);
				}
			});
		}
	}, [member_se]);

	return (
		<>
			<div id='wrap'>
				<div className='container'>
					<div className='content DrawLots'>
						<div className='visual'>
							<h1>
								<img
									src={`${IMG_URL}/images/draw-lots/tit.png`}
									alt='탄이와 함께하는 뽑기 이벤트'
								/>
							</h1>
							<div className='date'>10.19 - 11.05</div>
							<div className='drawlot-box'>
								<div className='drawlot'>
									<div className={`ball-area ${moveBalls} ${moveBalls2}`}>
										<span className='ball'></span>
										<span className='ball'></span>
										<span className='ball'></span>
										<span className='ball'></span>
										<span className='ball'></span>
										<span className='ball'></span>
										<span className='ball'></span>
										<span className='ball'></span>
										<span className='ball'></span>
										<span className='ball'></span>
										<span className='ball'></span>
										<span className='ball'></span>
										<span className='ball'></span>
										<span className='ball'></span>
										<span className='ball'></span>
									</div>
									<div className='drawlot-body'>
										<div className={`lever ${lever}`}>lever</div>
										<div className={`exit ${exitBall} ${turnBall}`}>
											<span className={`ball ${randomColorBall}`}></span>
											<i></i>
										</div>
									</div>
									{prizePopup !== 0 && (
										<PrizePopUp
											close={() => setPrizePopup(0)}
											rewardResult={_rewardResult}
											eventName={eventName}
											eventCategoryType={eventCategoryType}
										/>
									)}
								</div>
								{member_se > 0 && (
									<button
										className='btn-start'
										onClick={() => {
											window.MixPanelClickEventButton(
												eventName,
												eventCategoryType
											);
											handleStartClick();
										}}
									>
										start
									</button>
								)}
								<i className='deco'></i>
							</div>
						</div>
						<div className='possess-coin'>
							<dl>
								<dt>
									보유
									<br />
									동전 개수
								</dt>
								<dd>
									<span>{coinCount}</span>개
								</dd>
							</dl>
						</div>
						<div className='event-info howto'>
							<div className='tit-area'>
								<h2>
									<strong>하루 3개</strong> 동전 얻는 방법
								</h2>
							</div>
							<ul className='get-coin'>
								<li className={attendance ? 'on' : ''}>
									<div className='content'>
										<i></i>출석체크 완료
									</div>
									<div className='info'>동전 1개</div>
								</li>
								<li className={interiorTicket ? 'on' : ''}>
									<div className='content'>
										<i></i>인테리어 교환권 획득하기
									</div>
									<div className='info'>동전 2개</div>
								</li>
							</ul>
							<button
								className='btn-get-more'
								onClick={() => window.GoToTicket()}
							>
								교환권 얻으러 가기 &gt;
							</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default DrawLotsMain;
